<template>
  <!-- 검색 인풋 = AppInput 프리셋 (돋보기 prepend + X/ESC 클리어). 테마는 Themeable 자동 상속(하위 AppInput은 provide로 따라옴). -->
  <app-input
    class="app-search"
    :class="{ 'app-search--light': lightMode }"
    :value="value"
    :placeholder="placeholder"
    @input="$emit('input', $event)"
    @esc="$emit('input', '')"
  >
    <template #prepend>
      <v-icon class="app-search__icon" size="14">mdi-magnify</v-icon>
    </template>
    <template #append>
      <button v-if="value" class="app-search__clear" title="지우기" @mousedown.prevent @click="$emit('input', '')">
        <v-icon size="13">mdi-close</v-icon>
      </button>
      <!-- 소비처 추가 append (필터 버튼 등) — X 클리어 우측 -->
      <slot name="append"></slot>
    </template>
  </app-input>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import AppInput from "./AppInput.vue";

// AppInput 위의 검색 프리셋. v-model 지원, ESC/X로 클리어. auto-register 전역 등록.
//  테마: Themeable — prop 없으면 앱 테마/프로바이더 자동, dark/light prop은 오버라이드.
export default {
  name: "AppSearchInput",
  components: { AppInput },
  mixins: [Themeable],
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "검색…" },
  },
  computed: {
    lightMode() {
      return !this.isDark;
    },
  },
};
</script>

<style scoped>
/* 슬롯 콘텐츠(돋보기·X)는 이 컴포넌트 스코프에서 스타일. focus 색 강조는 AppInput의 focus-within 상속(currentColor 아님)이 아니라 상수색 유지. */
.app-search__icon {
  color: #6b6b7d !important;
}
.app-search__clear {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  cursor: pointer;
}
.app-search__clear .v-icon {
  color: #6b6b7d !important;
}
.app-search__clear:hover .v-icon {
  color: #e6e6ee !important;
}

/* ── light theme (슬롯 아이콘 색) ── */
.app-search--light .app-search__icon,
.app-search--light .app-search__clear .v-icon {
  color: #a29cb8 !important;
}
.app-search--light .app-search__clear:hover .v-icon {
  color: #37324a !important;
}
</style>
